<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-8">
      <div class="card shadow border-0 rounded-4">
        <div class="card-body p-4 p-md-5 text-center">
          <div class="verification-icon bg-primary bg-opacity-10 text-primary mx-auto mb-4">
            <i class="bi bi-envelope-check" aria-hidden="true"></i>
          </div>
          <h1 class="h3 mb-3">Verify your email</h1>
          <p class="text-secondary mb-2">We sent a verification link to</p>
          <p class="fw-semibold text-break mb-4">{{ email }}</p>
          <p class="text-muted">Open the email, select the verification link, then return here to finish setting up your YachtApp account.</p>

          <div class="alert alert-success text-start" role="status" *ngIf="message()">
            <i class="bi bi-check-circle me-2"></i>{{ message() }}
          </div>
          <div class="alert alert-danger text-start" role="alert" *ngIf="errorMessage()">
            <i class="bi bi-exclamation-circle me-2"></i>{{ errorMessage() }}
          </div>

          <div class="d-grid gap-2 mt-4">
            <button class="btn btn-primary" type="button" (click)="checkVerification()" [disabled]="isChecking()">
              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" *ngIf="isChecking()"></span>
              I've verified my email
            </button>
            <button class="btn btn-outline-secondary" type="button" (click)="resendVerification()" [disabled]="isResending() || resendCooldown() > 0">
              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" *ngIf="isResending()"></span>
              {{ resendCooldown() > 0 ? 'Resend available in ' + resendCooldown() + 's' : 'Resend verification email' }}
            </button>
          </div>
          <button class="btn btn-link text-secondary mt-3" type="button" (click)="useAnotherAccount()">Use another account</button>
        </div>
      </div>
    </div>
  </div>
</div>
